import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ProjectFormGroup } from './project-form-group.interface';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class ProjectFormModel {
  private formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    organizationId: 'organizationId',
    title: 'title',
    description: 'description',
    tag: 'tag',
  };

  public form: FormGroup<ProjectFormGroup>;

  constructor() {
    this.form = this.initForm();
  }

  private initForm(): FormGroup<ProjectFormGroup> {
    return this.formBuilder.group<ProjectFormGroup>({
      organizationId: new FormControl(),
      title: new FormControl('', [
        Validators.required,
        Validators.maxLength(128),
      ]),
      description: new FormControl(null, [Validators.maxLength(2500)]),
      tag: new FormControl(null, [Validators.maxLength(16)]),
    });
  }
}
